module.exports = __webpack_public_path__ + "static/logo-422637f2dacfd627f160c840e694f1ab.png";